import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/features/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeatureGrid from "../components/features/FeatureGrid";
import Cta from "../components/features/Cta";
import Testimonials from "../components/features/Testimonials";

const Features = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeatureGrid />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Features;
